import React from "react";

function PlayOverlay(props){
    require('./play-overlay.scss');
    return(
        <div className="mtv-play-overlay">
            <div className="icon-container">
            <svg width="46" height="46" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-489.000000, -116.000000)">
                        <g transform="translate(490.000000, 117.000000)">
                            <ellipse stroke="#FFFFFF" fillOpacity="0.200000003" fill="#000000" cx="22.0507614" cy="22.1690722" rx="22.0507614" ry="22.1690722"></ellipse>
                            <polyline fill="#FFFFFF" points="19.2944162 29.6250245 19.2944162 14.437326 29.0119112 22.0305077 19.2944162 29.6250245"></polyline>
                        </g>
                    </g>
                </g>
            </svg>
            </div>
        </div>
    )
}

export default PlayOverlay;